module.exports = __webpack_public_path__ + "static/img/TAQUITO.08c054b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/video-cover/TAQUITO.jpg
// module id = gSHU
// module chunks = 1